/* 🤖 this file was generated by svg-to-ts */
export const matIconVideocamOff: {
  name: 'videocam-off';
  data: string;
} = {
  name: 'videocam-off',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="m9.56 8-2-2-4.15-4.14L2 3.27 4.73 6H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.21 0 .39-.08.55-.18L19.73 21l1.41-1.41-8.86-8.86L9.56 8zM5 16V8h1.73l8 8H5zm10-8v2.61l6 6V6.5l-4 4V7c0-.55-.45-1-1-1h-5.61l2 2H15z"/></svg>`
};
